// @core
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIGet } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;

// @constants
const actionTypes = require('constants/actionTypes');
const { BROKER_NEWS_MAX_NEWS_LIMIT } = require('constants/index');

const eventsRequest = () => ({
    type: actionTypes.BROKER_GET_NEWS_REQUEST
});

const eventsSuccess = (data) => ({
    type: actionTypes.BROKER_GET_NEWS_SUCCESS,
    payload: {
        data: data
    }
});

const eventsFailure = (error) => ({
    type: actionTypes.BROKER_GET_NEWS_FAILURE,
    payload: {
        error
    }
});

const requestNews = (limit = BROKER_NEWS_MAX_NEWS_LIMIT) => (dispatch, getState) => {
    const immBrokerNews = getState().brokerNews;
    const hasBeenFetched = immBrokerNews.get('hasBeenFetched');
    const isFetching = immBrokerNews.get('isFetching');
    const hasError = immBrokerNews.get('hasError');

    if (hasBeenFetched || isFetching || hasError){
        return Promise.resolve();
    }

    const url = apiURLBuilder.getURL('brokerNews');

    const requestData = {
        query: {
            quantityGeneralNew: limit,
            quantityPesonaNew: limit,
            idioma: getLanguage()
        }
    };

    dispatch(eventsRequest());

    return APIGet(dispatch, url, requestData).then(
        response => dispatch(eventsSuccess(response)),
        error => dispatch(eventsFailure(error.error))
    );
};

const requestNewsById = (storyId, limit) => (dispatch, getState) => {
    const immBrokerNews = getState().brokerNews;
    const hasBeenFetched = immBrokerNews.get('hasBeenFetched');
    const isFetching = immBrokerNews.get('isFetching');
    const hasError = immBrokerNews.get('hasError');

    if (hasBeenFetched || isFetching || hasError){
        return Promise.resolve();
    }

    let url = apiURLBuilder.getURL('brokerNews');

    const requestData = {
        query: {
            quantityGeneralNew: limit,
            quantityPesonaNew: limit,
            idioma: getLanguage()
        }
    };

    dispatch(eventsRequest());

    return APIGet(dispatch, url, requestData).then(
        response => {
            if (response.response.find(news => news.story_id === storyId)) {
                dispatch(eventsSuccess(response));
            }
            else {
                const params = {
                    query: {
                        storyId: storyId,
                    }
                };

                return APIGet({
                    dispatch,
                    endpoint: 'brokerNewsByStoryId',
                    params: params,
                }).then(
                    responseById => {
                        response.response.push(responseById);
                        dispatch(eventsSuccess(response));
                    },
                    error => dispatch(eventsFailure(error.error))
                );
            }
        },
        error => dispatch(eventsFailure(error.error))
    );
};


module.exports = {
    requestNews,
    requestNewsById,
};
